import React from 'react'
import { CSSTransition } from 'react-transition-group'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import styles from './styles.module.scss'

const SlideDownUp = ({ shouldShow = true, appear = false, timeout = 300, children, className }) => {
  return (
    <CSSTransition
      in={shouldShow}
      appear={appear}
      timeout={timeout}
      classNames="slide-down-up"
      className={classNames(styles['slide-down-up'], className)}
      unmountOnExit
    >
      <div>{children}</div>
    </CSSTransition>
  )
}

SlideDownUp.propTypes = {
  shouldShow: PropTypes.bool,
  appear: PropTypes.bool,
  timeout: PropTypes.number,
  children: PropTypes.any,
  className: PropTypes.string,
}

export default SlideDownUp
